/***
 * 创建人：李珊
 * 时间：2020-12-12
 * 描述：素材库——素材管理——抓取源管理：分页查询 新增 编辑 查看 删除操作
 * 更新说明:
 */
declare var $;
import { Component, OnInit, ViewChild } from '@angular/core';
import { SwMassageConfirmComponent } from 'src/app/librarys/components/basic-components/sw-massage-confirm/sw-massage-confirm.component';
import { SwGridTableComponent } from 'src/app/librarys/components/basic-components/sw-table/sw-grid-table/sw-grid-table.component';
import { SwCreateModalComponentService } from 'src/app/librarys/serves/sw-create-modal-component.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { KmsService } from '../../../kms.service';
import { GrabSourceAddComponent } from '../grab-source-add/grab-source-add.component';
import { KmsEnum } from '../../../serves/kms-enum';
import { GrabSourceViewComponent } from '../grab-source-view/grab-source-view.component';

@Component({
  selector: 'app-grab-source-query',
  templateUrl: './grab-source-query.component.html',
  styleUrls: ['./grab-source-query.component.css']
})
export class GrabSourceQueryComponent implements OnInit {
  @ViewChild("swtable") swtable: SwGridTableComponent;
  @ViewChild("trim") trim: SwMassageConfirmComponent;     //确认删除弹框
  // 搜索网站名称
  websiteName = '';
  // 抓取类型
  crawlType = 0;
  // 抓取类型选项
  crawlTypeOptions = KmsEnum.crawlTypeOptions;
  // 表格数据
  datas: any = [];
  // 当前选中的数据
  selectedData: any = [];
  // 是否显示加载中
  isLoading: boolean = false;
  // 表格分页组件
  pageBase: any = {
    current: 1,
    size: 10
  }
  // 表格操作按钮
  toolbar = [
    { status: true, functionCode: 'add', functionName: '新增', icon: 'glyphicon glyphicon-plus', children: [] },
    { status: true, functionCode: 'delete', functionName: '批量删除', icon: 'glyphicon glyphicon-remove', children: [] }
  ];
  constructor(
    private box: SwMassageBoxService,
    private kmsService: KmsService,
    private create: SwCreateModalComponentService
  ) { }

  ngOnInit() {
    this.crawlTypeOptions.unshift({
      'id': 0,
      'text': '全部'
    });
    this.handleSelectClick();
  }

  //enter键触发搜索
  enterSearch(event) {
    if (event.keyCode == '13') {
      this.handleSelectClick();
    }
  }

  // 查询按钮方法
  handleSelectClick() {
    this.pageBase = {
      current: 1,
      size: 10
    };
    this.getData();
  }

  //获取数据
  getData() {
    this.isLoading = true;
    const params = {
      'websiteName': $.trim(this.websiteName),
      'crawlType': this.crawlType,
      'pageNum': this.pageBase.current,
      'pageSize': this.pageBase.size,
      'isDelete': false
    }
    this.kmsService.getCrawlWebsite(params).subscribe(
      data => {
        this.isLoading = false;
        if (data.code == '200') {
          this.pageBase = data.data;
          this.datas = data.data.records;
        } else {
          this.box.waring(data.msg);
        }
      }
    );
  }

  // 按钮点击事件
  handleOperationClick(event) {
    switch (event) {
      case "add": this.handleAddClick(); break; // 新增
      case 'delete': this.handleDeleteClick(); break; // 删除
    }
  }

  // 新增方法
  handleAddClick() {
    let param = { "upOrAdd": "Add", "selectedData": null };
    this.create.createModal(GrabSourceAddComponent, param, this.handleSelectClick.bind(this))
  }

  // 批量删除
  handleDeleteClick() {
    if (this.selectedData.length == 0) {
      this.box.danger('请至少选择一条数据！');
      return;
    }
    let ids = [];
    this.selectedData.forEach(item => {
      ids.push(item.websiteId);
    });
    this.delete(ids);
  }

  /**
  * 点击td中的按钮
  * @ignore
  */
  clickTdBtn(type, data) {
    //禁止冒泡
    event.stopPropagation();
    // 编辑
    if (type == 'edit') {
      let param = { "upOrAdd": "Edit", "selectedData": data };
      this.create.createModal(GrabSourceAddComponent, param, this.getData.bind(this))
    }
    // 查看
    else if (type == 'view') {
      let param = { "upOrAdd": "View", "selectedData": data };
      this.create.createModal(GrabSourceViewComponent, param)
    }
    // 删除
    else if (type == 'delete') {
      this.delete([data.websiteId]);
    }
  }

  // 表格选中行数据
  handleSelectData(event) {
    //获取当前选中的所有数据
    this.selectedData = event;
    //设置表格按钮组状态
    this.swtable.toolbarAllEnable();
    if (this.selectedData.length == 0) {
      this.swtable.toolbarDisable("delete");
    };
  }

  // 表格分页点击方法
  handlePageClick(event) {
    this.pageBase = event;
    this.getData();
  }

  // 重置数据
  handleReloadClick() {
    this.websiteName = '';
    this.crawlType = 0;
    this.pageBase = {
      current: 1,
      size: 10
    };
    this.getData();
  }

  // 表格列表 是否启用 开关 
  handleEnableSwitch(value, data) {
    data.websiteStatus = value ? 0 : 1;
    this.kmsService.saveOrUpdateCrawlWebsite(data).subscribe(
      data => {
        this.isLoading = false;
        if (data.code == '200') {
          this.box.success('操作成功！');
          this.getData();
        } else {
          this.box.waring(data.msg);
        }
      }
    );
  }

  // 删除方法
  delete(ids) {
    this.trim.openCLick("确认删除吗？", (data) => {
      if (data) {
        this.kmsService.deleteCrawlWebsiteById(ids).subscribe(
          data => {
            if (data["code"] == '200') {
              this.box.success("操作成功");
              this.handleSelectClick();
            } else {
              this.box.waring(data.msg);
            }
          }
        )
      }
    })
  }
}

